module.exports = __webpack_public_path__ + "static/media/4.1.6a75a524.jpg";